import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

const MoneyRefund = () => {
  return (
    <>
      <Header />
      <Box
        style={{
          marginTop: 80,
          width: (WIDTH * 90) / 100,
          marginLeft: (WIDTH * 5) / 100,
          paddingTop: (HEIGHT * 5) / 100,
          borderRadius: 10,
          backgroundColor: "white",
          marginBottom: (HEIGHT * 6) / 100,
          paddingBottom: (HEIGHT * 10) / 100,
        }}
      >
        <Typography
          variant="h4"
          style={{ textAlign: "center", marginBottom: (HEIGHT * 4) / 100 }}
        >
          Money Refund Request
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h6" gutterBottom>
                Request a Refund
              </Typography>
              <Typography variant="body1" gutterBottom>
                If you have purchased a product from CodeGigz, and you are not
                fully satisfied with your purchase, you can request a refund.
                Please fill out the form below with your details, and our
                customer service team will get back to you as soon as possible.
              </Typography>
              <TextField
                label="Order Number"
                variant="outlined"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Your Email"
                variant="outlined"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Refund Reason"
                variant="outlined"
                fullWidth
                margin="normal"
              />
              <TextField
                label="Additional Details"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                margin="normal"
              />
              <Button
                variant="contained"
                fullWidth
                style={{ marginTop: (HEIGHT * 2) / 100, backgroundColor: '#0f456c', color: '#fff' }}
              >
                Submit Refund Request
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </>
  );
};

export default MoneyRefund;
